import { render } from "./UpdateCampus.vue?vue&type=template&id=44a8918d"
import script from "./UpdateCampus.vue?vue&type=script&lang=js"
export * from "./UpdateCampus.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__